<template>
  <span>
      <v-dialog
        v-model="loginDialog"
        max-width="290"
      >
        <LoginModal @loggedIn="closeModals"></LoginModal>
      </v-dialog>

      <v-dialog
        v-model="signupDialog"
        max-width="290"
      >
        <SignupModal @signedUp="closeModals"></SignupModal>
      </v-dialog>




    <v-navigation-drawer app v-model="drawer" dark disable-resize-watcher>
      <v-list>
          <template v-for="(item, index) in items">
              <v-list-item :key="index">
                  <v-list-item-content>
                      <router-link :to="item.url">
                          {{item.title}}
                      </router-link>
                  </v-list-item-content>
              </v-list-item>
              <v-divider :key="`divider-${index}`"></v-divider>
          </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar>
      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-spacer class="hidden-md-and-up"></v-spacer>

      <router-link to="/">
        <img id="logo" src="../../assets/logo.png" />
      </router-link>

      <v-spacer class="hidden-sm-and-down"></v-spacer>
      <v-spacer class="hidden-md-and-up"></v-spacer>

      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn text v-for="(item, index) in items" :to="item.url" :href="item.link">{{
          item.title
        }}</v-btn>
      </v-toolbar-items>


      <!-- <v-toolbar-items class="hidden-sm-and-down">
        <v-menu open-on-hover bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-btn id="accountNavItem" text v-on="on" :ripple="false">
              Account
            </v-btn>
          </template>

          <v-list>
              <v-list-item v-if="isAuthenticated">
                  <v-list-item-title>{{accountID}}</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="isAuthenticated" @click="logout">
                  <v-list-item-title>Logout</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="!isAuthenticated" @click.stop="loginDialog = true">
                  <v-list-item-title>Login</v-list-item-title>
              </v-list-item>
              <v-list-item v-if="!isAuthenticated" @click.stop="signupDialog = true">
                  <v-list-item-title>Sign up</v-list-item-title>
              </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items> -->
    </v-app-bar>
  </span>
</template>

<script>
import LoginModal from '../modal/LoginModal.vue'
import SignupModal from '../modal/SignupModal.vue'

export default {
    name: "AppNavigation",
    components: {
        LoginModal,
        SignupModal
    },
    data: () => ({
        drawer: false,
        items: [
            { title: "신차장기", url: "/newcar" },
            { title: "중고차 장기", url: "/usedcar" },
            { title: "단기대여", url: "/shortterm" },
            { title: "기사포함대여", link: "http://www.limokorea.co.kr/login.do" },
            { title: "About Us", url: "/about" },
            { title: "Contact", url: "/contact" }
        ],
        loginDialog: false,
        signupDialog: false,
    }),
    computed: {
        isAuthenticated() {
            return this.$store.state.isAuthenticated;
        },
        accountID() {
            return this.$store.state.user.user.email
        }

    },
    methods: {
        logout() {
            this.$store.dispatch('userSignOut');
        },
        closeModals() {
            this.loginDialog = false;
            this.signupDialog = false;
        }
    }
};
</script>

<style>
#logo {
  height: 55px;
  margin-top: 8px;
}
v-navigation-drawer a {
  color: white !important;
  text-decoration: none;
}
</style>
